import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid, Row, Col } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import SettingsModal from "components/Settings/SettingsModal.js";
import { firestore } from "config/firebase.js";

class MonProfil extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSettingsModal: true,
            userData: null,
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.fetchUserData();
    }

    fetchUserData = async () => {
        const { user } = this.props;
        if (!user?.uid) return;

        try {
            this.setState({ loading: true, error: null });
            const userDoc = await firestore.collection('users').doc(user.uid).get();

            if (userDoc.exists) {
                this.setState({ 
                    userData: userDoc.data(),
                    loading: false
                });
            } else {
                this.setState({ 
                    error: "Aucune donnée utilisateur trouvée",
                    loading: false
                });
            }
        } catch (err) {
            this.setState({ 
                error: err.message,
                loading: false
            });
        }
    };

    closeSettings = () => {
        this.setState({ showSettingsModal: false });
        // Redirection vers la page d'accueil ou précédente
        this.props.history.goBack();
    };

    render() {
        const { user } = this.props;
        const { showSettingsModal, loading, error, userData } = this.state;

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="Mon Profil"
                                content={
                                    <div style={{ padding: '20px' }}>
                                        <div style={{
                                            textAlign: 'center',
                                            marginBottom: '30px',
                                            padding: '40px 20px',
                                            background: 'linear-gradient(120deg, #2980b9, #3498db)',
                                            borderRadius: '15px',
                                            boxShadow: '0 4px 15px rgba(41, 128, 185, 0.3)'
                                        }}>
                                            <h2 style={{
                                                color: 'white',
                                                marginBottom: '15px',
                                                fontSize: '32px',
                                                fontWeight: '600',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}>
                                                <i className="fa fa-user-circle" style={{ marginRight: '15px' }}></i>
                                                Informations Personnelles
                                            </h2>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.9)',
                                                fontSize: '18px',
                                                margin: 0,
                                                fontWeight: '300'
                                            }}>
                                                Consultez et modifiez vos informations de profil
                                            </p>
                                        </div>

                                        {loading && (
                                            <div style={{ textAlign: 'center', padding: '30px' }}>
                                                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                                    <span className="sr-only">Chargement...</span>
                                                </div>
                                                <p style={{ marginTop: '15px' }}>Chargement de vos informations...</p>
                                            </div>
                                        )}

                                        {error && (
                                            <div className="alert alert-danger" role="alert">
                                                <i className="fa fa-exclamation-triangle" style={{ marginRight: '10px' }}></i>
                                                {error}
                                            </div>
                                        )}

                                        {userData && !loading && !error && (
                                            <div style={{ marginTop: '20px' }}>
                                                <p style={{ textAlign: 'center', fontSize: '16px', color: '#555' }}>
                                                    Les détails de votre profil sont affichés dans la fenêtre modale.
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>

                <SettingsModal
                    userId={user?.uid}
                    show={showSettingsModal}
                    onClose={this.closeSettings}
                />
            </div>
        );
    }
}

MonProfil.propTypes = {
    user: PropTypes.object,
    history: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    user: state.user.user
});

export default connect(mapStateToProps)(MonProfil);
